/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { IndexDependencies } from './dependenciesIndexClass.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { rangeDependencies } from './dependenciesRange.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createRowTransform } from '../../factoriesAny.js';
export var rowTransformDependencies = {
  IndexDependencies,
  matrixDependencies,
  rangeDependencies,
  typedDependencies,
  createRowTransform
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesRowTransform.generated.js
// module id = 1460
// module chunks = 2